var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcentrating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    strokeWidth: 0,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.5 17.75c-125.028 2.135-223.03 231.994-9.188 461.625-197.34-240.608 9.41-548.496 174.157-289.03C287.353 66.332 222.42 16.744 163.5 17.75zm201.78 4.656c197.34 240.608-9.41 548.528-174.155 289.063C319.482 698.622 679.9 360.254 365.28 22.405zm-98.31 155.75c-42.422 0-76.814 34.392-76.814 76.813 0 42.42 34.392 76.81 76.813 76.81 42.42 0 76.81-34.39 76.81-76.81 0-42.422-34.39-76.814-76.81-76.814z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcentrating);
export default __webpack_public_path__ + "static/media/Concentrating.fcbc32fc1a3a276e6b3f348aaa619131.svg";
export { ForwardRef as ReactComponent };